import BasePage from "pages/base_page";
import React from "react";
import ReactDOM from "react-dom";
import ContactAuthorView from "views/contact_author_view";
import renderEditorialActionsMenu from "lib/renderEditorialMenu";
import ToggleLockUser from "components/Editorial/ToggleLockUser";

const EDITORIAL_ACTIONS_MENU_PATH = "/editorial/actions_menu/profiles/:user_id";

export default class ProfilePage extends BasePage {
  initialize(options) {
    this.renderContactAuthor = this.renderContactAuthor.bind(this);

    this.user_id = options.user_id;
    this.isAuthor = options.is_author;
    this.currentUserCanContactAuthors = options.currentUserCanContactAuthors;
    this.contactable = options.contactable;
    this.availableFor = options.availableFor;
    if (this.isAuthor) { this.renderContactAuthor(); }

    renderEditorialActionsMenu(EDITORIAL_ACTIONS_MENU_PATH.replace(":user_id", options.user_id));

    super.initialize(options);


    const toggleLockButtons = Array.from(document.querySelectorAll(".toggle-lock-user-button"));
    toggleLockButtons.forEach((button) => {
      const container = React.createElement(ToggleLockUser, {
        buttonClass: "button large",
        locked: button.dataset.locked === "true",
        userId: button.dataset.userId,
        userName: button.dataset.userName,
      });
      ReactDOM.render(container, button);
    });
  }

  renderContactAuthor() {
    const contactAuthor = new ContactAuthorView({
      user_id: this.user_id,
      currentUserCanContactAuthors: this.currentUserCanContactAuthors,
      contactable: this.contactable,
      availableFor: this.availableFor,
      el: this.$el.find(".profile-user-details"),
    });
    return this.$el.find(".profile-user-details").prepend(contactAuthor.el);
  }
}
